export const noCollisionDetection = () => [];
